import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";

interface UserAvatarProps {
  displayName: string | null | undefined;
  email?: string | null;
  pictureUrl?: string | null;
  size?: number;
  tooltip?: boolean;
}

export function getInitials(source: string): string {
  return source
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

function resolveLabel(displayName?: string | null, email?: string | null): string {
  if (displayName && displayName.trim()) return displayName.trim();
  if (email && email.trim()) return email.trim();
  return "Unknown";
}

function resolveInitialsSource(displayName?: string | null, email?: string | null): string {
  if (displayName && displayName.trim()) return displayName.trim();
  if (email && email.trim()) return email.split("@")[0];
  return "?";
}

export default function UserAvatar({
  displayName,
  email,
  pictureUrl,
  size = 32,
  tooltip = true,
}: UserAvatarProps) {
  const label = resolveLabel(displayName, email);
  const initials = getInitials(resolveInitialsSource(displayName, email));

  const avatar = (
    <Avatar
      src={pictureUrl ?? undefined}
      alt={label}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.42,
        bgcolor: "primary.main",
      }}
    >
      {initials || "?"}
    </Avatar>
  );

  if (!tooltip) return avatar;
  return (
    <Tooltip title={label} placement="top">
      {avatar}
    </Tooltip>
  );
}
